
























import { Vue, Component, Prop } from "vue-property-decorator";

import EventTypeSelect from "@share/common/event-type-select/EventTypeSelectPanel.vue";
import {
    AdminPanelEventsEnum,
    AdminPanelEventType,
    getAdminPanelEventName
} from "@share/common/admin-panel/AdminPanelEvents";
import { EventBus } from "@common/EventBus";

@Component({ components: { EventTypeSelect }})

export default class AdminPanel extends Vue {

    @Prop() resetConfirmText: string | undefined;
    @Prop({ default: true }) allowBack: boolean;
    @Prop() greenText: string;
    @Prop({ default: false }) greenDisabled: boolean;
    @Prop({ default: false }) greyDisabled: boolean;
    @Prop({ default: true }) needSaveAndRestButtons: boolean;
    @Prop() eventType?: AdminPanelEventsEnum | undefined;

    showEventTypeSelect = false;

    emitEvent(eventName: AdminPanelEventType) {
        this.$emit(eventName);
        if (this.eventType) {
            EventBus.$emit(getAdminPanelEventName(this.eventType, eventName));
        }
    }
}

